module.exports = __webpack_public_path__ + "static/media/logo-mobile-login.e40eb345.png";